<template>
    <div class="position-loader">
        <div class="loader">
            <fingerprint-spinner :animation-duration="1500" :size="size" :color="'#e0e2f4'"/>
        </div>
    </div>
</template>

<script>
    import {FingerprintSpinner} from 'epic-spinners'
    export default {
        name: "Loader",
        components: {
            FingerprintSpinner
        },
        data() {
            return{
                size: null
            }
        },
        created() {
            this.size = screen.height/3
            console.log('decrypting signal.. loading..')
        }
    }
</script>

<style lang="scss" scoped>
.position-loader{
    position: absolute;
    left: 50%;
    top: 33vh;
    transform: translate(-50%, 0);
}

.loader{
    position: relative;
}
</style>
